import { ValidationService } from './../../services/validation.service';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactory,
  ComponentFactoryResolver,
  OnInit,
  Renderer2,
  ViewChild, ViewContainerRef
} from '@angular/core';
import { SharedService } from '../../shared/shared.service';
import { FormBuilder } from '@angular/forms';
import { BackArrowComponent } from '../back-arrow/back-arrow.component';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { distinctUntilChanged, filter, pairwise } from 'rxjs/operators';
import { FormService } from '../../shared/form.service';
import { Subscription } from 'rxjs';
import { RouteInterceptorService } from '../../services/route-interceptor.service';
import { TranslateService } from "@ngx-translate/core";
import { LocalStorageService } from 'ngx-localstorage';
import { ProgressStepperDataService } from 'src/app/shared/progress-bar-data.service';

// import {RouteInterceptorService} from '../../services/route-interceptor.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit, AfterViewInit {
  @ViewChild('stepper', { read: ViewContainerRef, static: false }) stepper;
  @ViewChild('backArrow', { read: ViewContainerRef, static: false }) backArrow;
  mainForm;
  previousUrl;
  currentUrl;
  hideLeftArrowIcon = false;
  progressStepperTitle = "";
  customCurrentTitle = "GDPR and IDD consents";
  renderAllSteps = "true";
  stepsLabels;
  currentProgress = "0,33";
  currentStepIndex = '2';
  totalSteps = '4';
  labelList: any;
  errorBanner;


  constructor(
    public sharedService: SharedService,
    public formService: FormService,
    private router: Router,
    private chRef: ChangeDetectorRef,
    private validationService: ValidationService,
    private route: ActivatedRoute,
    public localStorage: LocalStorageService,
    public progressBarDataService: ProgressStepperDataService,
    public translateService: TranslateService) {
    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }
  stepClick($event) {
    if ($event == 1) {
      this.router.navigate(['start']);
    }
    if ($event == 2) {
      this.router.navigate(['package-selection']);
    }
    if ($event == 3) {
      this.router.navigate(['object-additional-details']);
    }
    if ($event == 4) {
      this.router.navigate(['summary']);
    }
  }
  goBackClick() {
    // this.sharedService.stepIndex = this.sharedService.stepIndex - 1;
    // if (this.sharedService.stepIndex < 0) {
    //   this.sharedService.stepIndex = 0;
    // }
    // this.router.navigate([this.sharedService.previousUrl]);
    this.progressBarDataService.goBackClick()

  }


  updateControl(snapshotData) {
    this.sharedService.setSanpshotData(snapshotData, () => {
      this.chRef.detectChanges();
    });
    if (this.translateService.currentLang == 'bg') {
      this.stepsLabels = ["Имущество", "Вашата оферта", "Собственик", "Вашата полица"];
    }
    else if (this.translateService.currentLang == 'en') {
      this.stepsLabels = ["About property", "Offer for you", "About owner", "Your policy"];
    }
    if (this.sharedService.stepIndex === 0 && this.sharedService.progress === 0 && this.sharedService.previousUrl !== null) {
    } else if (snapshotData.vehicle) {
    }
  }

  ngOnInit() {


    this.mainForm = this.route.snapshot.data.mainForm;
    let snapshotData: any = this.route.snapshot?.firstChild?.data;
    this.mainForm = snapshotData?.mainForm || this.mainForm || this.formService.getMainForm();
    this.updateControl(snapshotData);
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (this.route.snapshot?.data?.mainForm) {
          this.validationService.state = true;
          this.mainForm = this.route.snapshot.data.mainForm;
          if (event.url === '/details-1') {

          }
        }
        snapshotData = this.route.snapshot?.firstChild?.data;
        this.updateControl(snapshotData);
      });
    this.translateService.onLangChange.subscribe(() => {
      if (this.translateService.currentLang == 'bg') {
        this.stepsLabels = ["Имущество", "Вашата оферта", "Собственик", "Вашата полица"];
      }
      else if (this.translateService.currentLang == 'en') {
        this.stepsLabels = ["About property", "Offer for you", "About owner", "Your policy"];
      }
    });

    this.validationService.showErrorBanner$.subscribe((show)=>{
      this.errorBanner=show;
    })
  }

  closeBanner(){
    this.validationService.showErrorBannerSource$.next(false);
  }

  ngAfterViewInit() {
    document?.querySelector('.container-wrapper')?.scrollTo(0, 0);
    // setTimeout(() => {

    //   const factory: ComponentFactory<any> = this.resolver.resolveComponentFactory(BackArrowComponent);
    //   const componentRef = this.stepper.createComponent(factory);
    //   this.renderer.insertBefore(
    //     this.stepper.element.nativeElement.querySelector('div'),
    //     componentRef.location.nativeElement,
    //     this.stepper.element.nativeElement.querySelector('div').firstChild);
    // });
  }

  onActivate(event) {
    document?.querySelector('.container-wrapper')?.scrollTo(0, 0)
    //console.log('scroll_main');
  }
}
function goBackClick() {
  throw new Error('Function not implemented.');
}

